// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H11V9H2V2ZM13 2H22V13H13V2ZM2 11H11V22H2V11ZM13 15H22V22H13V15Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dashboard-1-filled')
export default class Dashboard1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dashboard-1-filled',
    }
  }
}
